<template>
  <div
    class="col px-0 d-flex content-detail"
    style="height: calc(100% - 110px)"
  >
    <home-list class="col-3 d-flex flex-column" />
    <member-info
      class="col-6 d-flex flex-column"
      :member="member"
      :homeId="homeId"
    />
    <activity-history class="col-3 d-flex flex-column" :histories="histories" />
  </div>
</template>

<script>
import axios from "axios";
import HomeList from "./HomeList";
import MemberInfo from "./MemberInfo";
import ActivityHistory from "./ActivityHistory";

export default {
  components: {
    HomeList,
    MemberInfo,
    ActivityHistory
  },
  data() {
    return {
      member: null,
      homes: [],
      histories: null,
      homeId: this.$route.params.homeId
    };
  },
  created() {
    if (this.homeId && this.homeId !== "all") {
      this.loadAll(this.homeId).then(() => {});
    }
  },
  watch: {
    $route(to) {
      if (to.params.homeId) {
        // this.member = null;
        // this.histories = null;
        this.homeId = to.params.homeId;
        this.loadAll(to.params.homeId).then(() => {});
      }
    }
  },
  methods: {
    async loadAll(homeId) {
      await this.loadMember(homeId);
      return this.loadMemberHistory(homeId);
    },
    loadMember(homeId) {
      return axios
        .get(
          `${process.env.HOST}/admin/member-management/homes/${homeId}/members`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`
            }
          }
        )
        .then(result => {
          this.member = result.data;
          return this.member;
        });
    },
    loadMemberHistory(homeId) {
      return axios
        .get(
          `${
            process.env.HOST
          }/admin/member-management/homes/${homeId}/members/histories`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`
            }
          }
        )
        .then(result => {
          this.histories = result.data;
          return result.data;
        });
    }
  }
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/admin/view/member/Member.vue